// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("st-close")[0];

// Only assign handlers if elements exist
if (btn && modal) {
  // When the user clicks on the button, open the modal
  btn.onclick = function() {
    modal.style.display = "block";
  };
}

if (span && modal) {
  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  };
}

if (modal) {
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}

function setViewListenersSt() {
  var $document = $_(document);

  $document.on('click', '.st-more-info-text', function(e) {
    $_(this).toggleClass('st-show');
    e.stopPropagation();
    e.stopImmediatePropagation();
  });
}